import script from "./PortfolioProjectCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioProjectCard.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioProjectCard.vue?vue&type=style&index=0&id=02c67346&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02c67346"]])

export default __exports__